import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tag, Timestamp, } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { conversationChannelAttributes } from 'lib-shared-legacy-types';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';
export const banHistoryColumns = [
    {
        label: '#',
        selector: function renderCsid({ csid }) {
            return _jsxs(Link, Object.assign({ to: `/conversation/${csid}` }, { children: ["#", csid] }));
        },
    },
    {
        label: 'Banned by',
        selector: function renderBannedBy({ banning_agent }) {
            return (_jsxs("div", Object.assign({ className: styles.user }, { children: [_jsx(Avatar, { user: banning_agent }), _jsx("div", Object.assign({ className: styles.userName }, { children: banning_agent.name }))] })));
        },
    },
    {
        label: 'Channel',
        selector: function renderChannel({ channel }) {
            var _a;
            return (_a = conversationChannelAttributes.get(channel)) === null || _a === void 0 ? void 0 : _a.prettyName;
        },
    },
    {
        label: 'Status',
        selector: function renderStatus({ unbanned_at }) {
            return (_jsx(Tag, Object.assign({ color: unbanned_at ? colors.neutral['500'] : colors.green['500'] }, { children: unbanned_at ? 'Inactive' : 'Active' })));
        },
    },
    {
        label: 'Banned on',
        selector: function renderBannedAt({ banned_at }) {
            return _jsx(Timestamp, { relative: true, time: banned_at });
        },
    },
];
export const banHistorySubColumns = [
    {
        label: 'Unbanned by',
        selector: function renderUnbannedBy({ unbanning_agent, }) {
            if (unbanning_agent) {
                return (_jsxs("div", Object.assign({ className: styles.user }, { children: [_jsx(Avatar, { user: unbanning_agent }), _jsx("div", Object.assign({ className: styles.userName }, { children: unbanning_agent.name }))] })));
            }
            return null;
        },
    },
    {
        label: 'Unbanned on',
        selector: function renderUnbannedOn({ unbanned_at, }) {
            if (unbanned_at) {
                return _jsx(Timestamp, { relative: true, time: unbanned_at });
            }
            return null;
        },
    },
];
